import React, { FC } from 'react';
import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import Heading from '../@shared/heading';
import Gallery from '../@shared/overlayCarouselPopup';
import { MediaGalleryModel } from './models/mediaGallery.model';
import { TMediaGalleryProps } from './types/mediaGallery.types';
import UnreleasedComponent from '../@shared/unreleasedComponent';

import '../../styles/@shared/media-gallery.scss';
import './styles.scss';

const MediaGallery: FC<TMediaGalleryProps> = (props) => {
  const model = new MediaGalleryModel(props);
  const isEEActive = props?.sitecoreContext?.pageEditing;

  // Component is unreleased
  if (model.isUnreleased) {
    return <UnreleasedComponent />;
  }

  return (
    <section className="media-gallery media-gallery-layout">
      <div className="media-gallery__wrapper">
        <div className="media-gallery__content">
          <Heading
            title={model.title}
            subtitle={model.description}
            eyebrow={model.eyebrow}
            editable={true}
            customTextTitle
            customTextSubtitle
            tag={model.headingTag}
          />
        </div>
        {model.slides && (
          <Gallery
            slides={model.slides}
            showNavDeck={true}
            showOverlayTitleAndDescription={true}
            isEE={isEEActive}
            customTextTitle
            customTextDescription
          />
        )}
      </div>
    </section>
  );
};

export default withSitecoreContext()(MediaGallery);
